import { Step } from "react-joyride";
import { iif } from "src/common/utils/functions";

type AreFeaturesPresent = {
  isBulkReviewTaskSelectionFeaturePresent: boolean;
  isReviewDecisionAndReasoningFeaturePresent: boolean;
  isExportMyTaskFeaturePresent: boolean;
  isSaveReviewTaskFeaturePresent: boolean;
  isPreviewAndSubmitReviewTaskTaskFeaturePresent: boolean;
};

export const getTourStepsForReviewTasksTab = (
  reviewId: string,
  areFeaturesPresent: AreFeaturesPresent
): Step[] => {
  let steps: Step[] = [
    {
      target: `.ReviewTaskContainer-${reviewId} .full-screen-button-container`,
      content:
        "Allow reviewer to veiw the review details in full screen mode for better visibility",
      disableBeacon: true,
      title: `"Full screen" feature`,
      spotlightPadding: 8,
    },
    {
      target: `th > .ant-table-selection`,
      content:
        "Allows to take bulk action by selecting multiple records of the tasks assigned to you.",
      disableBeacon: true,
      title: `"Bulk review tasks selection" feature`,
    },
    {
      target: `.ReviewTaskContainer-${reviewId} .review-decision-and-reasoning-container`,
      content:
        "As a reviewer you can quickly select the review decision along with the reason if there is a revision to access recommmended.",
      disableBeacon: true,
      disableScrolling: true,
      title: `"Review decisions & Reasoning" feature`,
    },
    {
      target: ".save-for-later-container",
      content:
        "Allows reviewers to conveniently save tasks, enabling them to easily return and complete them at a more suitable time.",
      disableBeacon: true,
      title: `"Save for later" feature`,
      spotlightPadding: 4,
    },
    {
      target: ".preview-and-submit-button",
      content: "Allow reviewers to review the saved tasks before final submission.",
      disableBeacon: true,
      title: `"Preview and Submit" feature`,
      spotlightPadding: 2,
    },
    {
      target: `.ReviewTaskContainer-${reviewId} .export-my-tasks-button-container`,
      content:
        "Allow reviewers to export their in-progress tasks to work offline and collaborate with other team members for input.",
      disableBeacon: true,
      title: `"Export my tasks" feature`,
      spotlightPadding: 6,
    },
    {
      target: `.ReviewTaskContainer-${reviewId} .column-select-container`,
      content:
        "Enables reviewers to customize which columns are visible on the screen for a personalized viewing experience.",
      disableBeacon: true,
      title: `"Display columns" selection feature`,
      spotlightPadding: 4,
    },
    {
      target: `.ReviewTaskContainer-${reviewId} .filter-button`,
      content:
        "Allows reviewers to narrow down and refine displayed information based on specific criteria.",
      disableBeacon: true,
      title: `"Filters" feature`,
      spotlightPadding: 4,
    },
  ];

  function removeStep(title: string) {
    return steps.filter((step) => step.title !== title);
  }

  iif(function removeBulkReviewTaskSelectionFeature() {
    if (!areFeaturesPresent.isBulkReviewTaskSelectionFeaturePresent) {
      steps = removeStep('"Bulk review tasks selection" feature');
    }
  });

  iif(function removeReviewDecisionAndReasoningFeature() {
    if (!areFeaturesPresent.isReviewDecisionAndReasoningFeaturePresent) {
      steps = removeStep('"Review decisions & Reasoning" feature');
    }
  });

  iif(function removeExportMyTaskFeaturet() {
    if (!areFeaturesPresent.isExportMyTaskFeaturePresent) {
      steps = removeStep('"Export my tasks" feature');
    }
  });

  iif(function removePreviewAndSubmitReviewTaskTaskFeature() {
    if (!areFeaturesPresent.isPreviewAndSubmitReviewTaskTaskFeaturePresent) {
      steps = removeStep('"Preview and Submit" feature');
    }
  });

  iif(function removeSaveReviewTaskFeature() {
    if (!areFeaturesPresent.isSaveReviewTaskFeaturePresent) {
      steps = removeStep('"Save for later" feature');
    }
  });

  return steps;
};
